angular.module('lf.common')

.controller('RedeemPinFormCtrl', function ($scope, $timeout, $http, lfFocus, lfFormSubmit, slideinService, videoPlayerService, scrolls, gtmService, popupsService, helpers) {
  var productDetailXHR = lf.data.xhr.productDetail;
  var isMobileUI = lf.data.xhr.client.mobileUI;
  
  $scope.data = {};
  videoPlayerService.init($scope, $scope.data);
  
  $scope.form = {};
  $scope.onCodeChange = onCodeChange;
  $scope.selectRedemptionItem = selectRedemptionItem;
  $scope.confirmRedemptionItem = confirmRedemptionItem;
  $scope.clearResponseData = clearResponseData;
  $scope.showProductQuickview = showProductQuickview;

  $scope.confirmRedeemSubsetSubmitted = false;

  $scope.showRedeemForm = false;
  $scope.expandRedeemForm = function() {
    $scope.showRedeemForm = true;
  };
  
  $scope.redeemCodes = {};
  $scope.clearRedeemCode = function(prefix) {
    $scope.redeemCodes[prefix + '1'] = $scope.redeemCodes[prefix + '2'] = $scope.redeemCodes[prefix + '3'] = $scope.redeemCodes[prefix + '4'] = '';

    var formCtrl = (prefix == 'uiTRUCode')? $scope.redeemTRUForm: $scope.redeemForm;
    formCtrl.$setPristine();
    formCtrl.$touched = false;
    formCtrl.$invalidRedeemCode = false;
  };
  
  $scope.launchLfc = function(section, params,createCookie, refererSection) {
	  helpers.utils.launchLfc(section, params,createCookie, refererSection);
  }
   
  $scope.gaTrackEvent = function(arg0, arg1, arg2, arg3) {
	  helpers.utils.gaTrackEvent(arg0, arg1, arg2, arg3);
  }
  
  $scope.clearRedeemState = function() {
	  $scope.redeemCodes.redeemState = null;
  };
  
  $scope.resetView = function () {
	  clearResponseData();
	  $scope.clearRedeemCode('uiRedeemCode');
	  $scope.clearRedeemState();
  }
  
  $scope.submitRedeemCode = function (event, valid) {
    // This flag is used as a hook to delay the display of validation errors
    // until after initial attempt at form submission
    event.preventDefault();
    $scope.requesting = true;
    var form = $(event.target);
    
    $scope.submitted = true;
    if (!valid) {
      return;
    }
    delete $scope.form.serviceErrors;
    lfFormSubmit(form, submitSuccess, submitError);
  };
  
  $scope.submitRedemptionItemSelection = function (event) {
    event.preventDefault();
    var form = $(event.target);
    lfFormSubmit(form, submitSuccess, submitError);
  };
  
  function submitSuccess(data) {
    console.log(data);
    $scope.requesting = false;
    
    if (data != null && typeof data != 'undefined') {
      if (data.success) {
        $scope.redeemResponseData = data;
        var redeemCodeType = data.redeemCodeType;
        switch (redeemCodeType) {
          case "giftCodeForValueSuccess":
            $scope.shop.accountBalance = data.accountBalance;
            // exchange gift for value success
            resetForm();
            if (!isMobileUI) {
              //popupsService.hide('giftCard');
              popupsService.show('valueCodeSuccess');
              $scope.clearRedeemCode('uiRedeemCode');
              $scope.clearRedeemState();
            }
            break;
            
          case "truCodeSuccess":
          case "subsetCodeSuccess":
          case "giftCodeForPackagesSuccess":
            // tru success, subset success & accept gift packages success
            showRedeemDownloadConfirmation(data);
            break;
        }
      } else {
        if (typeof data.errors != 'undefined') {
          $scope.form.serviceErrors = data.errors;
          $scope.serviceErrors = data.errors;
          $scope.confirmRedeemSubsetSubmitted = false;
        }
      }
    }
  }

  $scope.resetRedeemFormState = function() {
    $scope.redeemResponseData = null;
    $scope.truCodeEntered = false;
    $scope.confirmRedeemSubsetSubmitted = false;
    scrolls.scrollTop('main');
  }

  //The controller used on payment page
  $scope.useCreditCardSubmitted = false;

  $scope.onUseCreditCardSubmit = function () {
    $scope.useCreditCardSubmitted = true;
  }



    function submitError(data) {
    $scope.requesting = false;
    console.log('http error');
    clearResponseData();
  }
  
  function selectRedemptionItem (productId, pinType, redeemSubset) {
    var query = $.param({
      id: productId,
      pinType: pinType,
      redeemSubset: redeemSubset
    });
    $http.get(productDetailXHR + '?' + query).then(function (res) {
      $scope.product = res.data;
      if (isMobileUI) {
        slideinService.show('quickview');
      } else {
        popupsService.show('quickview');
      }
    });
  }
  
  function showProductQuickview(product) {
  	$scope.product = product;
  	if(isMobileUI) {
  		slideinService.show('quickview');
  	} else {
  		popupsService.show('quickview');
  	}
  }
  
  function confirmRedemptionItem() {
    $scope.confirmRedeemSubsetSubmitted = true;
    $timeout(function (){
      $scope.$broadcast('redemptionItemConfirmed');
    });
  }
  
  function showRedeemDownloadConfirmation(data) {
    // 1. LFConnectMode Only :: Trigger fetch device inventory
    if (!angular.isUndefined(data.fetchDeviceInventoryUrl) && data.fetchDeviceInventoryUrl != '') {
      //$http.get(encodeURI(fetchDeviceInventoryUrl + '?' + properties.join('&')));
    	helpers.utils.lfc.fetchDeviceInventory(data.fetchDeviceInventoryUrl);
    }

    var product = $scope.product || {};
    
    gtmService.pushRedeemSuccess(
      data.redeemCodeType,
      data.pinType,
      null,
      {
        id: product.id || '',
        reportingTitle: product.reportingTitle || '',
        skuId: data.skuIds
      }
    );

    // 2. Navigate the user to redeem confirmation screen
    var url = data.redeemConfirmPageUrl + (data.skuIds ? ('?skuIds=' + data.skuIds) : '');
    setTimeout(function() {
      window.location.href = encodeURI(url);
    }, 500);
  }
  
  /*
  function log(msg) {
    $http.get(lf.data.xhr.siteBaseUrl + '/xhr/data/log.jsp?log=' + encodeURIComponent('count ' + count++ + ': ' + msg));
  }
  */
  
  /*
   * This isn't elegant, but handles complicated requirements
   * whereby we need to auto-tab into the next redeem-code input field
   * on valid input. Also handles overflowing the contents of a paste
   * into the appropriate input fields. Probably a better way to do this
   * with directive(s)?
   */
  function onCodeChange($event, modelPropPrefix, modelPropCount) {
    var currentModelTarget = modelPropPrefix + modelPropCount;
    var val = $scope.form[currentModelTarget];
    
    if (angular.isUndefined(val)) {
      return;
    }
    
    val = val.replace(/-/g, '');
    $scope.form[currentModelTarget] = val;
    
    if (val.length == 4) {
      // Move focus to next field
      lfFocus(modelPropPrefix + (++modelPropCount));
      return;
    }
    
    
    if (val.length > 4) {
      var currentModelTarget;
      for (var i = modelPropCount; i < 5; i++) {
        currentModelTarget = modelPropPrefix + i;
        if (val.length <= 4) {
          $scope.form[currentModelTarget] = val;
          break;
        }
        $scope.form[currentModelTarget] = val.substring(0, 4);
        val = val.substring(4);
      }
      
      lfFocus(currentModelTarget);
    } 
  }
  
  function clearResponseData() {
    delete $scope.redeemResponseData;
  }
  
  function resetForm() {
    $scope.form = {};
    $scope.redeemForm.$setPristine(true);
    delete $scope.submitted;
  }
});
